import { useLocation } from 'react-router-dom'

const useCurrentPath = () => {
  const location = useLocation()
  const currentPath = location.pathname.slice(
    location.pathname.indexOf('/') + 1,
  )
  return { currentPath }
}

export default useCurrentPath
